import { useLingui } from "@lingui/react";
import { Helmet } from "react-helmet-async";

import { FeaturesSection } from "./sections/features";
import { HeroSection } from "./sections/hero";
import { HowItWorksSection } from "./sections/how-it-works";
import { PricingSection } from "./sections/pricing";
import { StatisticsSection } from "./sections/statistics";
import { TemplatesSection } from "./sections/templates";

export const HomePage = () => {
  const { i18n } = useLingui();

  return (
    <main className="relative isolate bg-background">
      <Helmet prioritizeSeoTags>
        <html lang={i18n.locale} />

        <title>VillageHut CV Builder - Professional CV Maker for Job Seekers</title>

        <meta
          name="description"
          content="Build professional, ATS-friendly CVs in 10 minutes. Multiple templates, Multiple Payment Methods. Download and apply today."
        />
      </Helmet>

      <HeroSection />
      <StatisticsSection />
      <FeaturesSection />
      <TemplatesSection />
      <PricingSection />
      <HowItWorksSection />
    </main>
  );
};
